define('Components/JobWidget/js/views/JobWidgetInstanceView',['jquery', 'underscore', 'testEmail', 'phoneUtils', 'WidgetInstanceView',
        'template!Components/JobWidget/templates/default', 'app','ApiRequest'],
    function ($, _,testEmail, phoneUtils, WidgetInstanceView,
              defaultTemplate, app,ApiRequest) {
        return WidgetInstanceView.extend({
            name: 'JobWidgetInstanceView',
            events: {
                'submit form': 'onSubmit',
            },
            getTemplate: function () {
                switch (this.model.getTemplate()) {
                    case 'default':
                    default:
                        return defaultTemplate;
                        break;
                }
            },

            onSubmit: function (e) {

                var view = this;
                e.preventDefault();
                var lastname = view.$('input[name=lastname]').val(),
                    firstname = view.$('input[name=firstname]').val(),
                    id = view.$('input[name=id]').val(),
                    address = view.$('input[name=address]').val(),
                    city = view.$('input[name=city]').val(),
                    email = view.$('input[name=email]').val(),
                    phone = view.$('input[name=phone]').val(),
                    message = view.$('textarea[name=message]').val(),
                    brand = view.$('input[name=brand]').val();

                if (
                    lastname == '' || phone == "" || city == '' || email == '' ) {
                    app.banNotice(t('Des champs obligatoires sont manuants'));
                    return;
                }

                if (!testEmail(email)) {
                    app.banNotice(t('Email invalid'));
                    return;
                }

                if (!phoneUtils.validate(phone)) {
                    app.banNotice(t('Phone invalid'));
                    return;
                }

                ApiRequest('WidgetJob',{
                        lastname: lastname,
                        firstname: firstname,
                        address: address,
                        city: city,
                        email: email,
                        id:id,
                        phone: phone,
                        message: message,
                        brand: brand,
                }).done(function (data) {
                    app.bottomNotice(app.t('Demande envoyée', 'Jobs'));
                    app.trigger('contactSuccessReset')
                }).fail(function (response) {
                    app.bottomNotice(response.responseJSON.error);
                    app.trigger('contactFailReset')
                });

            },


        })
    });
